// ---------------------------------------------------------------------
// <copyright file="index.tsx" company="WALC Inc."
// @author Naoya Abe
// (C) 2022 WALC Inc. All rights reserved.
// </copyright>
// ---------------------------------------------------------------------

import './components/index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './components/App';
import reportWebVitals from './components/reportWebVitals';

// Rootオブジェクトを作成する
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// 表示をレンダリングする
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
